module.exports = __webpack_public_path__ + "media/giveafuck.e0d8b955.mp3";